import styled from "styled-components";

export const ButtonContainer = styled.button`
  color: ${(p) => (p.$textColor ? p.$textColor : "#09090b")};
  font-family: DM Sans;
  font-size: 14px;
  font-weight: 600;
  line-height: 150%; /* 21px */
  letter-spacing: 0.07px;
  cursor: pointer;
  border: none;
  outline: none;

  display: inline-flex;
  flex-direction: row;
  gap: 8px;
  height: 40px;
  padding: 9px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: ${(p) => (p.$background ? p.$background : "#fff")};
  flex-shrink: 0;
  transition: transform 0.3s ease-in-out;

  &:hover {
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0px);
    background: #fff9;
  }

  &:disabled {
    cursor: not-allowed;
    transform: none !important;
    background: #fff;
  }
`;
